import { Subject } from 'rxjs';

const subject = new Subject();

export const RequestService = {
  start: (from: string) => subject.next( {from: from, start: true}),
  end: () => subject.next({from: 'none', start: false}),
  getRequestStatus: () => subject.asObservable()
};